const capitalize = (str = "Input") => {
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};

export default capitalize;
